import { render, staticRenderFns } from "./ace.vue?vue&type=template&id=3eaae87e"
import script from "./ace.vue?vue&type=script&lang=ts"
export * from "./ace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports